/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Injectable } from '@angular/core';
@Injectable()
export class PageResetService {

  /**
   * Creates an instance of PageResetService.
   *
   * @memberOf PageResetService
   */
  constructor() { }

  /**
   * @memberOf PageResetService
   */
  resetAll() {

  }
}
